/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const addressFields = ['city', 'county', 'lineText', 'state', 'type', 'zipcode'];
export const optionalAddressFields = ['additionalLineText', 'isDefault', 'id'];

// Check that at least 1 address has all required data on it and return it if it exists
export const verifyCompleteAddress = address => !!address && addressFields.every(field => address[field]);